import ExportingEventsSnippet from "../../../../contents/docs/migrate/snippets/exporting-events";
import * as React from 'react';
export default {
  ExportingEventsSnippet,
  React
};